// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  base_url: "https://java-apperone-backend.agiletechnologies.in/api/",
  //https://chaperoneapi.admindd.com/api/" "http://180.211.99.164:8092/api/",
  socket_base_url: "https://chaperonenode.admindd.com",
  firebase: {
    apiKey: "AIzaSyD1mzlvRZDUfTZqNict7ZZoA1wJD9euDkA",
    authDomain: "chaperone-271619.firebaseapp.com",
    databaseURL: "https://chaperone-271619.firebaseio.com",
    projectId: "chaperone-271619",
    storageBucket: "chaperone-271619.appspot.com",
    messagingSenderId: "32485901774",
    appId: "1:32485901774:web:5166596535289cbd57d79f",
    measurementId: "G-69H7DW2PQ0"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
